import { render, staticRenderFns } from "./RecordMessage.vue?vue&type=template&id=231c8388&scoped=true&"
import script from "./RecordMessage.vue?vue&type=script&lang=js&"
export * from "./RecordMessage.vue?vue&type=script&lang=js&"
import style0 from "./RecordMessage.vue?vue&type=style&index=0&id=231c8388&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231c8388",
  null
  
)

export default component.exports